import React, { memo } from "react";
import { ReactSVG } from "react-svg";

import { classNames } from "helpers";

import { SummaryContactLineProps } from "../types";

/** Redak brzog kontakta u zaglavlju pregleda (primarni email, telefon, adresa). */
const SummaryContactLine: React.FC<SummaryContactLineProps> = ({ icon, value, placeholder }) => {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <ReactSVG src={icon} className="w-4 h-4 stroke-slate-400 flex-shrink-0" />
      <span className={classNames("text-sm truncate", value ? "text-slate-700" : "text-slate-400")}>
        {value || placeholder}
      </span>
    </div>
  );
};

export default memo(SummaryContactLine);
